import { createBaseApi } from "./base.service";
import { RESOURCES } from "./resources";

export const pageViewsApi = createBaseApi<any>(RESOURCES.PAGE_VIEWS).injectEndpoints({
  endpoints: (build) => ({
    recordPageView: build.mutation<
      { ok: boolean; skipped?: boolean },
      { path: string; LoginId?: number; origin?: string; origem?: string }
    >({
      query: (body) => ({
        url: `/page-views`,
        method: "POST",
        body,
      }),
    }),
    getPageViews: build.query<
      Array<{ path: string; loginId?: number; data?: string; count: number }>,
      {
        loginId?: number;
        dataInicial?: string;
        dataFinal?: string;
        sistemaOnly?: boolean;
        aggregateByPath?: boolean;
      }
    >({
      query: (params) => ({
        url: `/page-views`,
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useRecordPageViewMutation, useGetPageViewsQuery } = pageViewsApi;
